export function getCurrentBlock(editorState) {
    const currentSelection = editorState.getSelection();
    const currentKey = currentSelection.getStartKey();
    return editorState.getCurrentContent().getBlockForKey(currentKey);
}